import React, { useState } from "react";
import { api } from "../../lib/api";
import { useFetch, act } from "../../lib/useFetch";
import { LANGS, PRIORITIES } from "../../lib/constants";
import { rub, toInputValue, fromInputValue } from "../../lib/format";
import AdminDialog, { Field, DialogButtons } from "./AdminDialog";

export default function OrderDialog({ order, presetUser, onClose, onSaved }) {
  const [users] = useFetch("/admin/users");
  const [services] = useFetch("/admin/services");
  const [form, setForm] = useState({
    user_id: order?.user_id || presetUser?.id || "", service_id: order?.service_id || "",
    price: order?.price ?? "", language: order?.language || presetUser?.language || "RU",
    deadline: toInputValue(order?.deadline), brief: order?.brief || "", priority: order?.priority || "normal",
  });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const pickService = (e) => {
    const s = services?.services.find((x) => x.id === e.target.value);
    setForm({ ...form, service_id: e.target.value, price: s ? s.price : form.price });
  };
  const pickUser = (e) => {
    const u = users?.users.find((x) => x.id === e.target.value);
    setForm({ ...form, user_id: e.target.value, language: u?.language || form.language });
  };

  const save = async (e) => {
    e.preventDefault();
    const payload = { ...form, price: form.price === "" ? null : Number(form.price), deadline: fromInputValue(form.deadline) };
    const res = order
      ? await act(api.put(`/admin/orders/${order.id}`, payload), "Заказ сохранён")
      : await act(api.post("/admin/orders", payload), "Заказ создан");
    if (res) onSaved();
  };

  return (
    <AdminDialog wide title={order ? "✏️ Заказ" : "➕ Новый заказ"} description={presetUser ? `Клиент: ${presetUser.name}` : "Цена подставляется из услуги, её можно изменить"} onClose={onClose} testid="order-dialog">
      <form onSubmit={save} className="space-y-3">
        <div className="grid sm:grid-cols-2 gap-3">
          <Field label="Клиент">
            <select required value={form.user_id} onChange={pickUser} disabled={!!presetUser} data-testid="order-user-select">
              <option value="">— выберите —</option>
              {users?.users.map((u) => <option key={u.id} value={u.id}>{u.name} · {u.email}</option>)}
            </select>
          </Field>
          <Field label="Услуга">
            <select required value={form.service_id} onChange={pickService} data-testid="order-service-select">
              <option value="">— выберите —</option>
              {services?.services.map((s) => <option key={s.id} value={s.id}>{s.title_ru} · {rub(s.price)}</option>)}
            </select>
          </Field>
          <Field label="Цена ₽"><input type="number" min={0} value={form.price} onChange={set("price")} data-testid="order-price-input" /></Field>
          <Field label="Язык клиента">
            <select value={form.language} onChange={set("language")} data-testid="order-language-select">
              {LANGS.map((l) => <option key={l} value={l}>{l}</option>)}
            </select>
          </Field>
          <Field label="Дедлайн"><input type="datetime-local" value={form.deadline} onChange={set("deadline")} data-testid="order-deadline-input" /></Field>
          <Field label="Приоритет">
            <select value={form.priority} onChange={set("priority")} data-testid="order-priority-select">
              {Object.entries(PRIORITIES).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
            </select>
          </Field>
        </div>
        <Field label="Бриф / ТЗ"><textarea rows={5} value={form.brief} onChange={set("brief")} data-testid="order-brief-input" /></Field>
        <DialogButtons onClose={onClose} testid="order" />
      </form>
    </AdminDialog>
  );
}
